import { useEffect, useRef } from "react";

type LineSeriesPoint = [number, number];

interface HighchartsLike {
  chart: (renderTo: HTMLElement, options: Record<string, unknown>) => void;
}

declare global {
  interface Window {
    Highcharts?: HighchartsLike;
  }
}

export const ProductivityTrends = () => {
  const chartRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!chartRef.current || typeof window === 'undefined') {
      return;
    }

    const highcharts = window.Highcharts;
    if (!highcharts) {
      return;
    }

    const generateVolumeData = (): LineSeriesPoint[] => {
      const points: LineSeriesPoint[] = [];
      const now = Date.now();
      for (let i = -29; i <= 0; i += 1) {
        const timestamp = now + i * 24 * 3600 * 1000;
        const value = Math.round(1000 + Math.random() * 250 + i * 5);
        points.push([timestamp, value]);
      }
      return points;
    };

    const generateAccuracyData = (): LineSeriesPoint[] => {
      const points: LineSeriesPoint[] = [];
      const now = Date.now();
      for (let i = -29; i <= 0; i += 1) {
        const timestamp = now + i * 24 * 3600 * 1000;
        const value = parseFloat((98.5 + Math.random() * 1.5 + i * 0.01).toFixed(2));
        points.push([timestamp, value]);
      }
      return points;
    };

    const options: Record<string, unknown> = {
      chart: { 
        type: 'line', 
        backgroundColor: 'transparent', 
        style: { fontFamily: 'Inter, sans-serif' } 
      },
        title: { text: null },
        credits: { enabled: false },
        xAxis: {
          type: 'datetime',
          labels: { style: { color: '#6b7270' } },
          lineColor: '#e4e6e5',
          tickColor: '#e4e6e5'
        },
        yAxis: [{
          title: { text: 'Processing Volume', style: { color: '#1e4841' } },
          labels: { style: { color: '#1e4841' } }
        }, {
          title: { text: 'Accuracy %', style: { color: '#bbf49c' } },
          labels: { style: { color: '#bbf49c' } },
          opposite: true,
          max: 100
        }],
        tooltip: { 
          shared: true, 
          backgroundColor: '#fbfbfc', 
          borderColor: '#e4e6e5', 
          borderRadius: 10 
        },
        legend: {
          align: 'center',
          verticalAlign: 'bottom',
          itemStyle: { color: '#232d2c', fontWeight: 'normal' }
        },
        series: [{
          name: 'Processing Volume',
          data: generateVolumeData(),
          color: '#1e4841'
        }, {
          name: 'Accuracy',
          yAxis: 1,
          data: generateAccuracyData(),
          color: '#bbf49c'
        }],
      };

      highcharts.chart(chartRef.current, options);
  }, []);

  return (
    <div className="bg-white p-6 rounded-2xl border border-brand-border">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-bold text-brand-primary">Productivity Trends</h3>
        <button className="h-7 px-2 py-1.5 bg-brand-secondary rounded-lg flex items-center gap-0.5 text-brand-primary text-xs">
          Last 30 Days <i className="fa-solid fa-caret-down ml-1"></i>
        </button>
      </div>
      <div ref={chartRef} className="h-[250px]"></div>
    </div>
  );
};
